import { Component } from '@angular/core';

import { FilterBaseComponent } from 'sc-common/shared/table/header/filters/filter-base.component';
import { TableColumn } from 'sc-common/shared/table/models/table-column';
import { TableStateService } from 'sc-common/shared/table/table-state.service';

@Component({
    templateUrl: 'text-filter.component.html',
    standalone: false
})
export class TextFilterComponent extends FilterBaseComponent {

    constructor(
        tableStateService: TableStateService,
        tableColumn: TableColumn) {

        super(tableStateService, tableColumn);
    }
}
